import { listPostnordJobStatuses, runPostnordJob, updatePostnordSchedule } from '@/api/shipments'
import { POSTNORD_JOB_DESCRIPTIONS, POSTNORD_JOB_LABELS } from '@/lib/postnordJobs'
import { JobsSection } from './JobsSection'

export function PostnordJobsSection(): React.ReactElement {
  return (
    <JobsSection
      title="PostNord"
      description="Bokning och spårning av leveranser."
      labels={POSTNORD_JOB_LABELS}
      descriptions={POSTNORD_JOB_DESCRIPTIONS}
      loadStatuses={listPostnordJobStatuses}
      runJob={runPostnordJob}
      updateSchedule={updatePostnordSchedule}
    />
  )
}
